import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SET_DETECTED_BY_FILTER,
} from './constants'
import {
  selectDateFilter,
  selectDetectedByFilter,
  selectGeneralFilter,
  selectPage,
  selectSearch,
} from './selectors'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      SEARCH_CHANGE,
      DATE_FILTER_CHANGE,
      PAGINATE_CHANGE,
      GENERAL_FILTER_CHANGE,
      SET_DETECTED_BY_FILTER,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.incidents.remediated)
      return true
    })
    .switchMap(() => {
      const state = store.getState()
      return api.resolutionCenter
        .getRemediatedIncidents(
          selectPage(state) || 1,
          selectSearch(state),
          selectGeneralFilter(state),
          selectDetectedByFilter(state)?.map((elem) => elem.value),
          getRangeFromDateFilter(selectDateFilter(state)),
          selectCompanyFilter(state)?.value
        )
        .map((response) => fetchDataSuccess(response?.response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
        .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
    })

export default combineEpics(fetchDataEpic)
